import { createDirtyChecker, compareByPaths } from "../../gvc/testNewForm/createDirtyChecker";
import { inputToAuditContext } from "../utils";

export function getDirtyChecker(id: string) {
  return createDirtyChecker(id, inputToAuditContext, compareByPaths({
    description: { path: "description" },
    tags: { path: "tags" },
  }));
}
